import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Reviews,
  StarReviewGraph,
  SubmissionModal,
  CONTEXT,
} from '@nexus/fff-ratings-and-reviews';
import EmptyReviews from 'Scenes/ProductDetail/RatingsAndReviews/EmptyReviews/EmptyReviews';
import ProductReviewCTA from 'Scenes/ProductDetail/ProductReviewCTA';
import env from 'utils/env';

import styles from './ProductRatings.module.css';

const ProductRatings = ({
  hasReviews,
  productRatingGraph,
  productId,
  productBrand,
  productName,
  loggedIn,
  productHasReviewed,
  sku,
  imgUrl,
  updateReviewedProducts,
  scrollToRef,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => setModalOpen(false);

  const openModal = () => setModalOpen(true);

  const handleReviewSuccess = (response) => {
    const data = response?.data?.items?.[0];
    const payload = { productId: data?.productId, hasReviewed: true };
    updateReviewedProducts(payload);
  };

  return (
    <div id="rate-and-review-container">
      {hasReviews ? (
        <>
          <div className={styles.RatingReviews__container}>
            <StarReviewGraph
              averageRating={productRatingGraph.averageRating}
              totalReviewCount={productRatingGraph.totalReviewCount}
              ratingDistribution={productRatingGraph.ratingDistribution}
            />
            <div className={styles.withSpace}>
              <ProductReviewCTA
                loggedIn={loggedIn}
                productHasReviewed={productHasReviewed}
                productHasReviews={hasReviews}
                ctaType="button"
                openReviewModal={openModal}
              />
            </div>
          </div>
          <div className={classNames([styles.withSpace, styles.divider])} />
          <div className={styles.reviewsSection}>
            <Reviews
              productId={productId}
              env={env.appEnv}
              brandName={productBrand}
              productName={productName}
              isLoggedIn={loggedIn}
              scrollToRef={scrollToRef}
            />
          </div>
        </>
      ) : (
        <EmptyReviews>
          <ProductReviewCTA
            loggedIn={loggedIn}
            productHasReviewed={productHasReviewed}
            productHasReviews={hasReviews}
            ctaType="button"
            openReviewModal={openModal}
          />
        </EmptyReviews>
      )}
      <SubmissionModal
        isOpen={modalOpen}
        brandName={productBrand}
        name={productName}
        imgUrl={imgUrl}
        productId={productId}
        sku={sku}
        context={CONTEXT.productAccordion}
        env={env.appEnv}
        closeModal={closeModal}
        onSuccess={handleReviewSuccess}
      />
    </div>
  );
};

ProductRatings.propTypes = {
  hasReviews: PropTypes.bool.isRequired,
  productRatingGraph: PropTypes.shape({
    averageRating: PropTypes.number,
    totalReviewCount: PropTypes.number,
    ratingDistribution: PropTypes.shape({
      [PropTypes.number]: PropTypes.number,
    }),
  }),
  productId: PropTypes.string.isRequired,
  productBrand: PropTypes.string,
  productName: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  productHasReviewed: PropTypes.bool.isRequired,
  sku: PropTypes.string.isRequired,
  imgUrl: PropTypes.string.isRequired,
  updateReviewedProducts: PropTypes.func.isRequired,
  scrollToRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
};

ProductRatings.defaultProps = {
  productRatingGraph: {
    averageRating: 0,
    totalReviewCount: 0,
    ratingDistribution: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
  },
  productBrand: '',
};

export default ProductRatings;
